import { resolveEnvironment } from "./resolve-environment";

export const ENVIRONMENT = resolveEnvironment(import.meta.env.MODE);
